import {Store} from '@ngrx/store';
import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {ActivatedRouteSnapshot} from '@angular/router';
import {AppState} from '../../../../../core/reducers';
import {Globals} from '../../../../../core/_base/crud/utils/globals.service';
import {OneAssignmentRequest} from '../../../../../core/assignment';

@Injectable()
export class AssignmentResolver implements Resolve<any> {
    constructor(private store: Store<AppState>,
                private global: Globals) {
    }

    resolve(route: ActivatedRouteSnapshot) {
        if (this.global.activeAssignmentId) {
            this.store.dispatch(new OneAssignmentRequest({id: this.global.activeAssignmentId}));
            return;
        }

        const assignmentId = Number(route.params.id);
        this.store.dispatch(new OneAssignmentRequest({id: assignmentId}));
    }
}
